import { Timeout } from '../../types'
import { HealthStateX } from '../../types/mfc'
import { COOKIE_PASSCODE } from '../constants'
import { HEALTH } from '../constants/enums'
import {
    FCSWS_HANDSHAKE_MEMBER,
    FCSWS_LOGIN_VERSION,
} from '../mfcLogic/mfcConstants'
import { getCookie } from '../utilities/cookies'
import { sample } from '../utilities/math'
import { pubSub } from './pubSub'
import { appState } from './state.app'

const initialHealthState: HealthStateX = {
    connecting: true,
    connected: false,
    paused: null,
    status: null,
    error: null,
}

const setHealthState = appState('HEALTH', initialHealthState)

export const getHealthState = () => appState().HEALTH

const setHealthStatusState = (status: HEALTH) => {
    setHealthState({
        modifications: {
            connecting: status === HEALTH.CONNECTING,
            connected: status === HEALTH.CONNECTED,
            paused: status === HEALTH.PAUSED,
            error: status === HEALTH.ERROR,
            status,
        },
    })
}

//
//
// Marc: I need to clean the stuff below soon..
//
//
const healthChanges = {
    interval: null as Timeout,
}

const setHealthInterval = () => {
    if (healthChanges.interval) clearInterval(healthChanges.interval)
    // Reload the site if they are logged in and the passcode cookie disappears (logged out)
    // or value has changed (logged in different account)
    const state = { previous: getCookie(COOKIE_PASSCODE) }
    healthChanges.interval = setInterval(function () {
        // Marc:
        // we need to remove "global.__APP_SIGNUP_TRACKER"
        // just doing this to fix a bug quickly for the release today
        // 12/20/2022
        if (global.__APP_SIGNUP_TRACKER) {
            state.previous = getCookie(COOKIE_PASSCODE)
            global.__APP_SIGNUP_TRACKER = false
        }

        if (getCookie(COOKIE_PASSCODE) !== state.previous) {
            location.reload()
        }
    }, 2000)
}

const healthStateMutatorsClosure =
    (state = { intervalError: null }) =>
    (event) => {
        const {
            data: { status },
        } = event

        if (status === HEALTH.CONNECTED) {
            setHealthInterval()
        }

        if (status === HEALTH.ERROR) {
            clearInterval(state.intervalError)
            state.intervalError = setInterval(() => {
                tryFCSConnection()
            }, 30000)
        }

        setHealthStatusState(status)

        const { status: previousStatus } = getHealthState()
        pubSub.HEALTH.emit('HEALTH', {
            previous: previousStatus,
            current: status,
        })
    }

export const healthStateMutators = healthStateMutatorsClosure()

function tryFCSConnection() {
    const { websocket_servers: sockets } = window.__MFC_APP_SERVERS__
    const server = sample(Object.keys(sockets))
    const url = 'wss://' + server + '.myfreecams.com/fcsl'
    const instance = new WebSocket(url)

    instance.onopen = () => {
        instance.send(FCSWS_HANDSHAKE_MEMBER + '\n\0')
        instance.send(`1 0 0 ${FCSWS_LOGIN_VERSION} 0 1/guest:guest\n\0`)
    }

    instance.onmessage = () => {
        location.reload()
    }
}
